import React, { useState, useEffect, useWindowFocus, act } from "react";

import {
  Link,
  Route,
  Routes,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";

import { auth, firebase } from "../Firebase/config";
// eslint-disable-next-line
import {
  onSnapshot,
  orderBy,
  limit,
  collection,
  addDoc,
  query,
  where,
  getDocs,
  deleteDoc,
  doc,
  setDoc,
  getDoc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  FieldValue,
  getCountFromServer,
} from "@firebase/firestore";

import {
  admin,
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendEmailVerification,
  onAuthStateChanged,
  deleteUser,
} from "@firebase/auth";

import Classes from "./Mapofstudentsgclassroom/Mapofstudentsgclassroom";

// eslint-disable-next-line
import NavBar from "./Navbar";

import "./App.css";

function App() {

  
  const [temparray, setTemparray] = useState();

  const [selectedclass, setSelectedclass] = useState();
  const [activeid, setActiveid = useState] = useState();
  const [activename, setActivename] = useState();

  const [selectedclass2, setSelectedclass2] = useState();
  const [activeid2, setActiveid2] = useState();
  const [activename2, setActivename2] = useState();
  const [activeemail2, setactiveemail2] = useState();

  const [currentclass, setCurrentclass] = useState();

  const [currentclasses, setCurrentclasses] = useState();
  const [currentstudents, setCurrentstudents] = useState();

  const [accesstoken, setAccesstoken] = useState();
  const [refreshtoken, setRefreshtoken] = useState();
  const [expiryDate, setExpiryDate] = useState();

  const [emailsreceived, setEmailsreceived] = useState();

  const [astheycome, setAstheycome] = useState([]);
  const [town, setTown] = useState("");
  const [state, setState] = useState("");
  const [school, setSchool] = useState("");

  const [userDataLoaded, setUserDataLoaded] = useState(false);
  // Add a state to trigger reload if loading takes too long
  const [reloadKey, setReloadKey] = useState(0);
    const [summaryStats, setSummaryStats] = useState([]);

      const [showSummary, setShowSummary] = useState(false);
  const [isProcessingQueue, setIsProcessingQueue] = useState(false);

  const [messageQueue, setMessageQueue] = useState([]);

  const auth = getAuth();

  const { only2studentid, studentid, classid, language, role, id } =
    useParams();

  // Minimal useEffect to confirm mounting in all environments
  useEffect(() => {
    console.log("✅ Getyourgcstudents.js mounted.");
  }, []);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const urlId = urlParams.get("id");
    const dataStoredInDatabase = urlParams.get("dataStoredInDatabase");

    console.log("🔍 URL Params:", {
      urlId,
      dataStoredInDatabase,
    });

    if (!urlId || dataStoredInDatabase !== "true") {
      console.warn("⚠️ id or dataStoredInDatabase not present in URL, skipping Firestore fetch");
      setUserDataLoaded(true);
      return;
    }

    const fetchUserData = async () => {
      try {
        const docRef = doc(firebase, "users", urlId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const userData = docSnap.data();

          if (userData.empty) {
            console.warn("⚠️ No user found with ID:", id);
            setUserDataLoaded(true); // Mark as loaded even if no user found
            return;
          }

          setAccesstoken(userData.access_token || "");
          setRefreshtoken(userData.refresh_token || "");
          setExpiryDate(userData.expiry_date || "");

          if (userData.town) {
            setTown(userData.town);
            console.log("✅ Town set:", userData.town);
          } else {
            console.warn("⚠️ No town data found for user");
          }

          if (userData.state) {
            setState(userData.state);
            console.log("✅ State set:", userData.state);
          } else {
            console.warn("⚠️ No state data found for user");
          }

          if (userData.school) {
            setSchool(userData.school);
            console.log("✅ School set:", userData.school);
          } else {
            console.warn("⚠️ No school data found for user");
          }

          if (userData.activeclassid) {
            setActiveid(userData.activeclassid);
            console.log("✅ Active class ID set:", userData.activeclassid);
          } else {
            console.warn("⚠️ No active class ID found for user");
          }
          if (userData.activeclassname) {
            setActivename(userData.activeclassname);
            console.log("✅ Active class name set:", userData.activeclassname);
          } else {
            console.warn("⚠️ No active class ID found for user");
          }

          if (userData.fetchStudents && userData.fetchStudents.students) {
            setTemparray(userData.fetchStudents.students);
            console.log("✅ Students array set from Firestore:", userData.fetchStudents.students.length);
          }

          let dataFound = true;

          if (dataFound) {
            console.log("✅ User data fetch completed successfully");
          } else {
            console.warn("⚠️ No data was processed from the query results");
          }
        } else {
          console.warn("⚠️ No document found in Firestore for user id:", urlId);
        }
      } catch (error) {
        console.error("❌ Error fetching user data:", error);
        console.error("❌ Error stack:", error.stack);

        // Set default values on error
        console.log("🔄 Setting default values due to error");
        setTown("");
        setState("");
        setSchool("");
      } finally {
        setUserDataLoaded(true);
        console.log("🎉 User data loading complete - ready for next steps");
      }
    };

    console.log("🔄 About to call fetchUserData...");
    fetchUserData()
      .then(() => {
        console.log("✅ fetchUserData promise resolved");
      })
      .catch((error) => {
        console.error("❌ fetchUserData promise rejected:", error);
      });
  }, [id]);

  useEffect(() => {
    setAstheycome([]);
  }, []);


  useEffect(() => {
    console.log("🔄 Student processing useEffect triggered");
    console.log("📊 Dependencies:", {
      temparray: temparray ? "defined" : "undefined",
      activeid: activeid ? "defined" : "undefined",
      town: town || "empty",
      state: state || "empty",
      school: school || "empty",
    });

    // Check all required dependencies
    if (!temparray || !activeid) {
      console.warn("⚠️ Missing required dependencies - temparray or activeid");
      return;
    }

    // Optional: Wait for location data if needed for creating new students
    // Remove this check if location data is not critical
    if (!town || !state || !school) {
      console.warn("⚠️ Location data not yet available, waiting...");
      return;
    }

    console.log("✅ All dependencies available, starting student processing");

    async function processStudents() {
  console.log("looking for activeId:", activeid);
  try {
    setSummaryStats([]);
    setShowSummary(false);
    setMessageQueue(["🔄 Starting student synchronization process"]);
    setIsProcessingQueue(true);

    const updateProgress = (msg) => {
      console.log(msg);
      setMessageQueue(prevQueue => [...prevQueue, msg]);
    };
    const addSummaryStat = (msg) => {
      console.log(msg);
      setSummaryStats(prev => [...prev, msg]);
    };

    // 1. Get current class roster
    updateProgress("Getting current class roster...");
    let currentStudentIds = [];
    let studentIdsInClass = [];
    let currrentarray = [];
    try {
      const classDoc = await getDoc(doc(firebase, "classesbeingtaught", activeid));
      if (classDoc.exists()) {
        const classData = classDoc.data();
        currentStudentIds = classData.students || [];
        updateProgress(`📋 Current roster has ${currentStudentIds.length} students`);
      } else {
        updateProgress("⚠️ Class document not found");
      }
    } catch (error) {
      updateProgress("❌ Error getting current student roster");
      console.error("❌ Error getting class document:", error);
    }

    updateProgress("📡 Querying existing students in class");
    const q = query(
      collection(firebase, "users"),
      where("classlist", "array-contains", activeid)
    );
    const querySnapshot = await getDocs(q);

    // Use a for...of loop so we can await inside the loop
    for (const docSnap of querySnapshot.docs) {

      // ...existing code...
      const percents = {
        id: activeid,
        penaltyminutes: 0,
        level: "No Consequences For Lateness",
        passdetails: [],
        passesallowedinweekifonpenalty: 2,
        selected: false,
        assignmentgrade: -1,
        assignmentname: "",
        studentGrades: { allGrades: [], courseId: -1, lastUpdated: "", studentProfile: {}, summary: {} }
      };
  try {
        // Read the user's doc to decide whether we need to set the [activeid] object
        // Use docSnap (the loop variable) instead of userData which is not defined here
        const studentDataInLoop = docSnap.data();
        const userDocRef = doc(firebase, "users", docSnap.id);
        const userDocSnap = await getDoc(userDocRef);

        // Determine if the activeid property is missing or empty ("", null, or empty object)
        let needsActiveProp = true;
        if (userDocSnap.exists()) {
          const userDocData = userDocSnap.data();
          const prop = userDocData ? userDocData[activeid] : undefined;
          needsActiveProp = (
            prop === undefined ||
            prop === null ||
            prop === "" ||
            (typeof prop === "object" && Object.keys(prop).length === 0)
          );
        }

        // Build update object conditionally
        const updates = {};
        if (needsActiveProp) {
          updates[activeid] = percents;
        }
        // Always ensure membership in classlist and teacherlist
        updates.classlist = arrayUnion(activeid);
        updates.teacherlist = arrayUnion(id);
            await updateDoc(userDocRef, updates);

        // Ensure the class document has this student
        await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
          students: arrayUnion(docSnap.id),
        });

        if (needsActiveProp) {
          updateProgress(`✅ Added existing user to class and initialized ${activeid}: ${studentDataInLoop.email}`);
        } else {
          updateProgress(`✅ Added existing user to class (no changes to ${activeid}): ${studentDataInLoop.email}`);
        }
      } catch (error) {
        // Use docSnap.data()?.email for logging if needed
        updateProgress(`❌ Error updating existing user: ${docSnap.data()?.email || docSnap.id}`);
        console.error("❌ Error updating existing user:", error);
      }
      // ...existing code...

      const studentData = docSnap.data();
      currrentarray.push({
        id: studentData.id,
        email: studentData.email,
        localfirstname: studentData.localfirstname,
        locallastname: studentData.locallastname,
        parentemail: studentData.parentemail,
        parentlanguagecode: studentData.parentlanguagecode,
      });
    }

    // 3. Build normalized email lists for comparison
    const googleClassroomEmails = temparray.map(s => s.email?.toLowerCase().trim());
    const keptStudents = [];
    const removedStudents = [];

    for (const existingStudent of currrentarray) {
      const normalizedEmail = existingStudent.email?.toLowerCase().trim();
      if (googleClassroomEmails.includes(normalizedEmail)) {
        keptStudents.push(existingStudent);
        setAstheycome(prev => [...prev, existingStudent]);
        // Find matching Google Classroom student for ID
        const matchingGoogleStudent = temparray.find(
          s => s.email?.toLowerCase().trim() === normalizedEmail
        );
        studentIdsInClass.push({
          gender: existingStudent.gender || "she",
          studentId: matchingGoogleStudent?.id || "",
          firebasestudentid: existingStudent.id,
          firstName: existingStudent.localfirstname || "",
          lastName: existingStudent.locallastname || "",
          email: existingStudent.email || "",
          parentemail: existingStudent.parentemail || "",
          parentlanguagecode: existingStudent.parentlanguagecode || "en",
        });
        updateProgress(`✅ Kept student: ${existingStudent.email}`);
        // Ensure they're in the class students array
        try {
          await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
            students: arrayUnion(existingStudent.id),
          });
        } catch (error) {
          updateProgress(`❌ Error keeping student: ${existingStudent.email}`);
          console.error("❌ Error keeping student:", error);
        }
      } else {
        removedStudents.push(existingStudent);
        updateProgress(`🗑️ Student to remove: ${existingStudent.email}`);
      }
    }

    // 4. Remove students no longer in Google Classroom
    updateProgress(`🔄 Removing ${removedStudents.length} students...`);
    let updatedStudentsList = currentStudentIds.filter(studentId =>
      !removedStudents.some(student => student.id === studentId)
    );
    for (const student of removedStudents) {
      if (!student.id) continue;
      try {
        const studentDoc = await getDoc(doc(firebase, "users", student.id));
        if (studentDoc.exists()) {
          const studentData = studentDoc.data();
          const newClassList = (studentData.classlist || []).filter(e => e !== activeid);
          const newTeacherList = (studentData.teacherlist || []).filter(e => e !== id);
          await updateDoc(doc(firebase, "users", student.id), {
            [activeid]: "",
            classlist: newClassList,
            teacherlist: newTeacherList,
          });
          updateProgress(`✅ Removed student from class: ${student.email}`);
        }
      } catch (error) {
        updateProgress(`❌ Error removing student: ${student.email}`);
        console.error("❌ Error removing student:", error);
      }
    }
    if (removedStudents.length > 0) {
      try {
        await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
          students: updatedStudentsList,
        });
        updateProgress(`✅ Updated class roster after removals`);
        addSummaryStat(`📊 Students removed from class: ${removedStudents.length}`);
      } catch (error) {
        updateProgress(`❌ Error updating class roster`);
        console.error("❌ Error updating class roster:", error);
      }
    }

    // 5. Find new students to add
    const newStudents = temparray.filter(googleStudent =>
      !keptStudents.some(kept => kept.email?.toLowerCase().trim() === googleStudent.email?.toLowerCase().trim())
    );
    addSummaryStat(`📊 New students processed: ${newStudents.length}`);

    // 6. Check if new students already exist in the system
    let found = [];
    let notfound = [];
    for (const item of newStudents) {
      try {
        const usersQuery = query(
          collection(firebase, "users"),
          where("email", "==", item.email)
        );
        const usersSnapshot = await getDocs(usersQuery);
        if (!usersSnapshot.empty) {
          usersSnapshot.forEach((docss) => {
            const userData = docss.data();
            setAstheycome(prev => [...prev, userData]);
            found.push(userData);
            studentIdsInClass.push({
              gender: userData.gender || "she",
              studentId: userData.googleclassroomid || item.id || "",
              firebasestudentid: userData.id,
              firstName: userData.localfirstname || "",
              lastName: userData.locallastname || "",
              email: userData.email || "",
              parentemail: userData.parentemail || "",
              parentlanguagecode: userData.parentlanguagecode || "en",
            });
            updateProgress(`✅ Added existing user: ${userData.email}`);
          });
        } else {
          notfound.push(item);
          updateProgress(`🆕 New user to create: ${item.email}`);
        }
      } catch (error) {
        updateProgress(`❌ Error looking up user: ${item.email}`);
        console.error("❌ Error looking up user:", error);
      }
    }
    addSummaryStat(`📊 Existing users found: ${found.length}`);
    addSummaryStat(`📊 New users created: ${notfound.length}`);

    // 7. Add existing users to the class (update their records)
    for (const userData of found) {
      const percents = {
        id: activeid,
        penaltyminutes: 0,
        level: "No Consequences For Lateness",
        passdetails: [],
        passesallowedinweekifonpenalty: 2,
        selected: false,
        assignmentgrade: -1,
        assignmentname: "",
        studentGrades: { allGrades: [], courseId: -1, lastUpdated: "", studentProfile: {}, summary: {} }
      };
      try {
        await updateDoc(doc(firebase, "users", userData.id), {
          [activeid]: percents,
          classlist: arrayUnion(activeid),
          teacherlist: arrayUnion(id),
        });
        await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
          students: arrayUnion(userData.id),
        });
        updateProgress(`✅ Added existing user to class: ${userData.email}`);
      } catch (error) {
        updateProgress(`❌ Error updating existing user: ${userData.email}`);
        console.error("❌ Error updating existing user:", error);
      }
    }

    // 8. Create new user accounts
    for (const item of notfound) {
      try {
        const uid = item.id || item.googleclassroomid;
        const data1 = {
          id: uid,
          googleclassroomid: item.id || item.googleclassroomid,
          localfirstname: item.localfirstname,
          locallastname: item.locallastname,
          email: item.email,
          passwordactual: "'Sign Up' Needed",
          role: "Student",
          currentclass: activeid,
          classlist: [activeid],
          teacherlist: [id],
          town: town,
          state: state,
          school: school,
          parentlanguage: "English",
          language: "",
          languagecode: "",
          parentlanguagecode: "en",
          parentemail: [],
          phonenumber: "",
          parentphonenumber: [],
          [activeid]: {
            id: activeid,
            penaltyminutes: 0,
            level: "No Consequences For Lateness",
            passdetails: [],
            behaviorlist: [],
            passesallowedinweekifonpenalty: 2,
            selected: false,
            assignmentgrade: -1,
            assignmentname: "",
            studentGrades: { allGrades: [], courseId: -1, lastUpdated: "", studentProfile: {}, summary: {} }
          },
        };
        setAstheycome(prev => [...prev, data1]);
        await setDoc(doc(firebase, "users", uid), data1);
        await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
          students: arrayUnion(uid),
        });
        studentIdsInClass.push({
          gender: item.gender || "she",
          studentId: item.id || item.googleclassroomid,
          firebasestudentid: uid,
          firstName: item.localfirstname || "",
          lastName: item.locallastname || "",
          email: item.email || "",
           parentemail: item.parentemail || "",
           parentlanguagecode: item.parentlanguagecode || "en",
           languagecode: item.languagecode || "en",
        });
        updateProgress(`✅ Created new user: ${item.email}`);
      } catch (error) {
        updateProgress(`❌ Error creating new user: ${item.email}`);
        console.error("❌ Error creating new user:", error);
      }
    }

    // 9. Final update: set studentIds array for the class
    try {
      console.log(`Attempting to update studentIds for class ${activeid}`, {
        studentCount: studentIdsInClass.length,
        firstFewStudents: studentIdsInClass.slice(0, 3),
        uniqueEmails: new Set(studentIdsInClass.map(s => s.email)).size
      });
      addSummaryStat(`📊 Total students in class roster: ${studentIdsInClass.length}`);
            // Prepare a deduplicated array of firebase student ids for the .students field
      const studentsArray = Array.from(
        new Set(
          studentIdsInClass
            .map(s => s.firebasestudentid)
            .filter(Boolean)
        )
      );

      // Update the class doc with both detailed studentIds (objects) and the students (firebase ids)
      await updateDoc(doc(firebase, "classesbeingtaught", activeid), {
        studentIds: studentIdsInClass,
        students: studentsArray,
      });

      updateProgress(`✅ Successfully updated studentIds and students for class ${activeid}`);      addSummaryStat(`✅ Class roster successfully updated (students count: ${studentsArray.length})`);
    } catch (error) {
      updateProgress(`❌ Error updating studentIds for class`);
      console.error(`❌ Error updating studentIds for class ${activeid}:`, error);
      alert(
        "Error Updating Class Roster",
        `Failed to update student IDs: ${error.message}`,
        [{ text: "OK" }]
      );
    }

    addSummaryStat(`🎉 Student processing completed successfully`);
    console.log("✅ processStudents completed");
  } catch (error) {
    console.error("❌ Error in student processing:", error);
    setMessageQueue(prevQueue => [...prevQueue, `❌ Error: ${error.message}`]);
    setShowSummary(true);
  }
}

    console.log("🔄 Starting processStudents...");
    processStudents()
      .then(() => {
        console.log("✅ processStudents completed");
      })
      .catch((error) => {
        console.error("❌ processStudents failed:", error);
      });
  }, [temparray, activeid, town, state, school, id]);

  //gooogle claassroom classes
  useEffect(() => {
    if (typeof selectedclass2 != "undefined") {
      setActiveid2(selectedclass2.id);
      setActivename2(selectedclass2.name);
    }
  }, [selectedclass2]);

  //claassesss from the database
  useEffect(() => {
    if (typeof selectedclass != "undefined") {
      setActivename(selectedclass.classname);
    }
  }, [selectedclass]);

  // If loading takes more than 2 seconds, reload the page
  useEffect(() => {
    if (!userDataLoaded) {
      const timeout = setTimeout(() => {
        if (!userDataLoaded) {
          console.warn("⏳ Still loading after 2 seconds, reloading page...");
          window.location.reload();
        }
      }, 2000);
      return () => clearTimeout(timeout);
    }
  }, [userDataLoaded]);

  // Show loading indicator until userDataLoaded is true
  if (!userDataLoaded) {
    return (
      <div className="App22">
         <NavBar
        role={role}
        temparray={currentclasses}
        activename2={activename2}
        selectedclass={selectedclass}
        setSelectedclass={setSelectedclass}
        activename={activename}
        //because it is an endpoint than you need to returrn from.
        noclasschangeandmainmenuonly={true}
      />
      <div className="App">
        <header className="App-header"> <h2>Loading user data...</h2></header>
        </div>
      </div>
    );
  }

  return (
    <div className="App22">
      <NavBar
        role={role}
        temparray={currentclasses}
        activename2={activename2}
        selectedclass={selectedclass}
        setSelectedclass={setSelectedclass}
        activename={activename}
        //because it is an endpoint than you need to returrn from.
        noclasschangeandmainmenuonly={true}
      />
      <div className="App">
        <header className="App-header">
          {/* 
            <Link to="/" style={{ textDecoration: 'none' }}>
          Return Home
          </Link> */}

          <Classes
            currentclass={currentclass}
            activename={activename}
            activename2={activename2}
            databaseactivename={activename}
            setSelectedclass={setSelectedclass2}
            activeid2={activeid2}
            selectedclass={selectedclass2}
            temparray={temparray}
            id={id}
            activeid={activeid}
            astheycome={astheycome}
             setAstheycome={setAstheycome} 
          />
        </header>
      </div>
    </div>
  );
}

export default App;
